import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Field, TextInput } from "@/components/FormKit";
import { brand } from "@/theme/themeTokens";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email.trim(), password);
    setLoading(false);
    if (res.ok) navigate("/today", { replace: true });
    else setError(res.message || "Invalid credentials");
  };

  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      <div className="flex flex-1 flex-col justify-center px-5 py-10">
        <div className="mx-auto w-full max-w-sm">
          <div className="mb-8 flex flex-col items-start">
            <Logo />
            <h1 className="mt-6 font-heading text-2xl font-extrabold tracking-tight text-slate-900">
              Sign in
            </h1>
            <p className="mt-1 text-sm text-slate-500">
              {brand.tagline} · {brand.family}
            </p>
          </div>

          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <Field label="Email">
              <TextInput
                testid="login-email-input"
                type="email"
                autoComplete="email"
                inputMode="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
              />
            </Field>
            <Field label="Password">
              <TextInput
                testid="login-password-input"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
              />
            </Field>

            {error && (
              <div
                data-testid="login-error-alert"
                className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2.5 text-sm font-medium text-rose-700"
              >
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="min-h-[52px] w-full rounded-lg bg-teal-700 font-semibold text-white shadow-sm transition-colors hover:bg-teal-800 disabled:opacity-60"
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
      <footer className="pb-safe px-5 py-4 text-center text-xs text-slate-400">
        {brand.name} {brand.version} · {brand.phase}
      </footer>
    </div>
  );
}
